










































// noinspection TypeScriptCheckImport
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.min.js';
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js';
import 'jquery-resizable-dom/dist/jquery-resizable.min.js';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js';
import 'trumbowyg/dist/plugins/fontfamily/trumbowyg.fontfamily.min.js';
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'WysiwygEditor',
    components: {
        Trumbowyg,
    },
})
export default class WysiwygEditor extends Vue {
    @Prop() private value;

    get model() {
        return this.value;
    }
    set model(val) {
        this.$emit('input', val);
    }

    private isErrorDialogActive = false;

    private trumbowygConfig = {
        tagsToRemove: ['script', 'link'],
        resetCss: true,
        defaultLinkTarget: '_blank',

        tagClasses: {
            ul: 'ul-circle', // it's a class on the rendering side that will add the dots
        },

        btnsDef: {
            // Image drop-down
            image: {
                dropdown: ['insertImage'],
                ico: 'insertImage',
            },
        },

        btns: [
            ['viewHTML'],
            ['foreColor', 'backColor'],
            ['indent', 'outdent'],
            ['table'],
            ['fontsize'],
            ['formatting'],
            ['strong', 'em', 'del'],
            ['superscript', 'subscript'],
            ['link'],
            ['image'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ['unorderedList', 'orderedList'],
            ['horizontalRule'],
            ['removeformat'],
            ['fullscreen'],
        ],

        plugins: {
            resizimg: {
                minSize: 64,
                step: 16,
            },
            fontsize: {
                sizeList: ['10px', '11px', '12px', '13px', '14px', '18px', '24px', '36px'],
                allowCustomSize: true,
            },
            fontfamily: {
                fontList: [
                    { name: 'Avenir', family: 'Avenir, Helvetica, Arial, sans-serif' },
                    { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                    { name: 'Arial Black', family: 'Arial Black, Gadget, sans-serif' },
                    { name: 'Impact', family: 'Impact, Charcoal, sans-serif' },
                    { name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif' },
                    { name: 'Times New Roman', family: 'Times New Roman, Times, serif' },
                ],
            },
        },
    };
}
